import React from 'react';
import { Image, Text, View } from 'react-native';
import { icon_bill } from '../../../../utils/ImagesManagementUtils';
import { LocStr } from '../../../../utils/Utils';
import { bv_address_bank, data_10_11_2020, money_amount_77 } from '../../../../utils/DictionaryManagementUtils';
import {
  textPrimary_10_0, textPrimaryCta_12_2, textSecondary_8_0, textSecondary_9_3,
} from '../TextComponent/TextStyle';

const BillListComponent = ({
  globJSON,
  language,
  simPlatform,
  subCategoryId,
  amount = money_amount_77,
  address = bv_address_bank,
  marginTop = 0,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { select_bill } = globJSON.configurations.services[subCategoryId];
  const myStyles = {
    container: {
      marginTop,
      alignSelf: 'center',
      padding: 8,
      width: 205,
      height: 72,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      borderColor: colors.border_light_color,
      borderWidth: 1,
      backgroundColor: colors.app_background_color,
      marginBottom: 10,
    },
    textWithIcon: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 6,
      marginBottom: 6,
    },
    iconBillStyle: {
      width: 12,
      height: 12,
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.textWithIcon}>
        <Text style={[textSecondary_9_3(globJSON, simPlatform)]}>{address}</Text>
        <Image
          fadeDuration={0}
          style={myStyles.iconBillStyle}
          source={icon_bill}
        />
      </View>
      <View style={myStyles.textWithIcon}>
        <Text style={textPrimary_10_0(globJSON, simPlatform)}>{amount}</Text>
        <Text style={textSecondary_8_0(globJSON, simPlatform)}>
          {LocStr(data_10_11_2020, language)}
        </Text>
      </View>
      <Text style={textPrimaryCta_12_2(globJSON, simPlatform)}>{select_bill.pay_now}</Text>
    </View>
  );
};
export default BillListComponent;
